module.exports = __webpack_public_path__ + "static/media/gallery-17.cf514c4f.jpg";